import { render } from "./ExamCities.vue?vue&type=template&id=54912945"
import script from "./ExamCities.vue?vue&type=script&lang=js"
export * from "./ExamCities.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__